import {
  Component,
  Input,
  TemplateRef,
  ViewChild
} from '@angular/core';

@Component({
  selector   : 'wor-wizard-step',
  styles: [ require('./wizard.component.scss') ],
  template: require('./wizard.step.component.html')
})
export class WizardStepComponent {
  @Input() isSkippable = false;

  @ViewChild('template', { read: TemplateRef, static: true })
  template!: TemplateRef<any>;
}
